import 'babel-polyfill'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import TreeView from "vue-json-tree-view"
import vuetify from '@/plugins/vuetify'

import Vuelidate from 'vuelidate'
import {store} from './store'

const fb = require('./firebaseConfig.js')

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueRouter)
Vue.use(TreeView)
Vue.use(vuetify)



// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {

    if (!app) {
        if (user) {
          store.commit('setCurrentUser', user)
          store.dispatch('fetchUserProfile')
      }
      app = new Vue({
        store,
        router,
        vuetify,
        render: h => h(App)
      }).$mount('#app');

    }
})